import React from "react";

const SkeletonInput = ({ height = "h-12" }: { height?: string }) => (
  <div className={`w-full bg-gray-200 rounded-md ${height}`} />
);

const SkeletonProgramForm: React.FC = () => {
  return (
    <div className="flex flex-1 pt-5 animate-pulse">
      <div className="flex-1">
        <div className="flex gap-8 w-full">
          {/* Left Side */}
          <div className="w-1/2 space-y-4">
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput />
            </div>
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput height="h-24" />
            </div>
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput />
            </div>
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput />
            </div>
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput />
            </div>
            <div className="flex w-full space-x-4">
              <div className="w-1/2">
                <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
                <SkeletonInput />
              </div>
              <div className="w-1/2">
                <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
                <SkeletonInput />
              </div>
            </div>
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <div className="flex gap-4">
                <div className="w-1/2 h-5 bg-gray-300 rounded" />
                <div className="w-1/2 h-5 bg-gray-300 rounded" />
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="w-1/2 space-y-4">
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput height="h-[3rem]" />
            </div>
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput height="h-[3rem]" />
              <div className="h-3 w-3/4 bg-gray-300 mt-2 rounded" />
            </div>
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput height="h-[3rem]" />
            </div>
            <div>
              <div className="h-4 w-1/2 bg-gray-300 rounded mb-3" />
              <SkeletonInput height="h-[3rem]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonProgramForm;
